// extracted by mini-css-extract-plugin
export default {"card":"Card_card__v1nSo","cardAction":"Card_cardAction__chVEA","cardImage":"Card_cardImage__sHFXS","avatar":"Card_avatar__845Ja","cardImageWrapper":"Card_cardImageWrapper__DPQ7s"};